import { ClassName } from '@/interfaces';

export const Trash: React.FC<ClassName> = ({ className }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M14.0004 4.48633C13.9871 4.48633 13.9671 4.48633 13.9471 4.48633C10.4204 4.13299 6.90043 3.99966 3.41377 4.35299L2.05377 4.48633C1.77377 4.51299 1.5271 4.31299 1.50043 4.03299C1.47377 3.75299 1.67377 3.51299 1.9471 3.48633L3.3071 3.35299C6.85377 2.99299 10.4471 3.13299 14.0471 3.48633C14.3204 3.51299 14.5204 3.75966 14.4938 4.03299C14.4738 4.29299 14.2538 4.48633 14.0004 4.48633Z"
				fill="#FF0043"
			/>
			<path
				d="M5.82047 2.44124L5.67631 3.25607L5.81294 2.44248L5.81304 2.44187C5.86976 2.10153 5.92086 1.85434 6.06932 1.67091C6.11918 1.60931 6.1926 1.5409 6.30947 1.48184C6.25587 1.51194 6.20345 1.54918 6.154 1.59547C6.0069 1.73315 5.94084 1.90024 5.90337 2.0313C5.86947 2.14988 5.84589 2.29011 5.82386 2.42107C5.82273 2.42782 5.8216 2.43455 5.82047 2.44124ZM7.13318 1.33967C7.01149 1.33967 6.89379 1.34209 6.78436 1.35179C6.88462 1.33979 6.99804 1.33301 7.12651 1.33301H8.87318C8.99607 1.33301 9.10523 1.33941 9.20235 1.35082C9.10023 1.34218 8.99177 1.33967 8.87984 1.33967H7.13318Z"
				fill="#FF0043"
				stroke="#FF0043"
			/>
			<path
				d="M3.43194 6.09502C3.43221 6.09472 3.4325 6.09444 3.43278 6.09417C3.43324 6.09443 3.43358 6.09468 3.43383 6.0949C3.43395 6.095 3.43404 6.09509 3.4341 6.09516C3.43413 6.09532 3.43418 6.09556 3.43421 6.09589L3.86731 12.8056L3.8673 12.8056L3.86758 12.8095L3.86916 12.8313C3.88435 13.0415 3.89969 13.2538 3.93127 13.4442C3.89909 13.2529 3.88165 13.0403 3.86514 12.8063L3.43194 6.09502ZM4.1745 14.1023C4.0636 13.9474 3.99644 13.7653 3.95224 13.5555C3.99645 13.763 4.0746 13.9845 4.23831 14.1754C4.28145 14.2258 4.32799 14.2711 4.3777 14.312C4.28998 14.2443 4.22477 14.1726 4.1745 14.1023ZM12.5663 6.09631C12.5666 6.09602 12.5669 6.09576 12.5672 6.09552L12.1342 12.8049C12.1341 12.8054 12.1341 12.8059 12.1341 12.8064C12.1274 12.9005 12.1206 12.9912 12.1128 13.0784C12.1195 12.9943 12.1251 12.909 12.1307 12.8242L12.1319 12.8062L12.1319 12.8056L12.5649 6.0977C12.5652 6.09734 12.5656 6.09686 12.5663 6.09631ZM11.7659 14.1754C11.8175 14.1153 11.8605 14.0521 11.8966 13.9873C11.875 14.0272 11.8511 14.0655 11.8247 14.1023C11.7966 14.1416 11.7638 14.1814 11.725 14.2206C11.739 14.206 11.7526 14.191 11.7659 14.1754Z"
				fill="#FF0043"
				stroke="#FF0043"
			/>
			<path
				d="M9.10672 11.5H6.88672C6.61339 11.5 6.38672 11.2733 6.38672 11C6.38672 10.7267 6.61339 10.5 6.88672 10.5H9.10672C9.38005 10.5 9.60672 10.7267 9.60672 11C9.60672 11.2733 9.38005 11.5 9.10672 11.5Z"
				fill="#FF0043"
			/>
			<path
				d="M9.66732 8.83301H6.33398C6.06065 8.83301 5.83398 8.60634 5.83398 8.33301C5.83398 8.05967 6.06065 7.83301 6.33398 7.83301H9.66732C9.94065 7.83301 10.1673 8.05967 10.1673 8.33301C10.1673 8.60634 9.94065 8.83301 9.66732 8.83301Z"
				fill="#FF0043"
			/>
		</svg>
	);
};
